import { useSelector } from 'react-redux';

import { selectIsSubCompanyUser } from 'store/auth/selectors';

/**
 * Returns true when the messages (team-chat) tab should be visible in the bottom nav.
 * Mirrors the gating logic used by `HeaderChatBell` in the desktop `Header`:
 * the tab is hidden for sub-company (TPO broker) users because those endpoints 403 for them.
 *
 * @returns {boolean}
 */
const useMessagesTabEnabled = () => {
  const isSubCompanyUser = useSelector(selectIsSubCompanyUser);

  return !isSubCompanyUser;
};

export default useMessagesTabEnabled;
